export const menuItems = [
    {
        id: 1,
        label: "MENU",
        isTitle: true
    },
    {
        id: 2,
        label: "Dashboard",
        icon: "bx-home-circle",
        link: "/administration"
    },
    {
        id: 3,
        label: "Subscriptions",
        icon: "bx-user",
        link: "/administration/subscriptions"
    },
    {
        id: 4,
        label: "Release",
        icon: "bx-money",
        link: "/administration/release",
    }
];

